/* Keeps the cart drawer summary pinned (Isaac, 20 Oct 2026).
   Horizon decides "sticky" once, when the drawer opens, and again only when a cart event carries a
   promise. The bundle add to cart (assets/hl-bundle.js) opens the drawer BEFORE its content has been
   re-rendered, so on the first add the summary was missing, the state was set to "false", and the
   checkout button scrolled away at the bottom. Here the same rule (summary under half the drawer)
   is re-applied whenever the drawer content changes. Writes an attribute only, never DOM children,
   so it cannot trigger itself. */
(function () {
  'use strict';
  var THRESHOLD = 0.5, queued = false;

  function recalc() {
    queued = false;
    var dlg = document.querySelector('#cart-drawer dialog');
    if (!dlg) return;
    var dh = dlg.getBoundingClientRect().height;
    if (dh <= 0) return; // closed: Horizon recalculates when it opens
    var sum = dlg.querySelector('.cart-drawer__summary');
    var content = dlg.querySelector('.cart-drawer__content');
    var v = 'false';
    if (sum && content && sum.getBoundingClientRect().height / dh <= THRESHOLD) v = 'true';
    if (dlg.getAttribute('cart-summary-sticky') !== v) dlg.setAttribute('cart-summary-sticky', v);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { recalc(); setTimeout(recalc, 350); });
  }

  function start() {
    var host = document.querySelector('#cart-drawer');
    if (!host) return;
    // Horizon morphs the cart in place, which is not always a childList change, so watch broadly.
    // recalc only WRITES when the value changes, so this cannot loop.
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true, attributes: true, characterData: true });
    window.addEventListener('resize', schedule);
    // belt and braces while the drawer is open: images and add ons change the height after the DOM settles
    setInterval(function () { if (host.querySelector('dialog[open]')) recalc(); }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
